import React from 'react';
import { Button, Card } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

interface Props {
  disabled: boolean;
  onAdd: () => void;
}

const CollectionsCard: React.FC<Props> = ({ disabled, onAdd }: Props) => (
  <Card bodyStyle={{ padding: '6px' }}>
    <Button
      type="primary"
      size="large"
      icon={<PlusOutlined />}
      disabled={disabled}
      onClick={onAdd}
    >
      Agregar colecta
    </Button>
  </Card>
);

export default CollectionsCard;
